import Link from 'next/link';
import React from 'react';
import Icon from '@/app/components/Icon';
import { useDispatch } from 'react-redux';
import { handleChatMenu } from '@/redux/reducers/chat-link-reducer';
import TextSmall from '../../Typography/TextSmall';

function HelpAndStoreLocator() {
  const dispatch = useDispatch();

  const chatWindowHandler = (e) => {
    e.stopPropagation();
    dispatch(handleChatMenu());
  };
  return (
    <div className="flex items-center gap-[24px]">
      <div
        role="presentation"
        onClick={chatWindowHandler}
        className="flex items-center gap-[4px] hover:cursor-pointer group"
      >
        <Icon type="chat" width={18} height={18} color="#ffffff" />
        <TextSmall
          text="Chat with Us"
          className="text-sm lg:text-sm lg:leading-5 text-white font-medium group-hover:underline"
        />
      </div>

      <Link
        prefetch={false}
        href="/store-locator"
        className="flex items-center gap-[4px] group hover:cursor-pointer"
        passHref
        aria-label="Store Locator"
      >
        <Icon type="location" />
        <TextSmall
          text="Store Locator"
          className="text-sm lg:text-sm lg:leading-5 text-white font-medium group-hover:underline"
        />
      </Link>
    </div>
  );
}

export default HelpAndStoreLocator;
